import React from 'react'
import { DonateGiftAid } from 'guest-payment'
import { connect } from 'transfer/utils/p2p-connect'
import content from 'pp-react-l10n'
import { changeGiftAidCheckbox } from '../../actions/Actions'
import LINKS from '../../../../../config/links.json'
import serverProps from '../../utils/serverProps'

let i18n = content('transfer/page/preview')

const DONATE_GIFT_PERCENTAGE = 1.25

type Props = {
  isAlreadyEnrolled: boolean,
  isGiftAidChecked: boolean,
  donorAddress: {},
  giftAidTextObj: {},
  handleGiftAidChange: () => void,
}
type State = {
  giftAidItCheckboxStatus: boolean,
}

class Donate extends React.Component<Props, State> {
  state = {
    giftAidItCheckboxStatus:
      this.props.isAlreadyEnrolled || this.props.isGiftAidChecked,
  }
  handleGiftAidOption = giftAidState => {
    this.setState({ giftAidItCheckboxStatus: giftAidState })
    this.props.handleGiftAidChange(giftAidState)
  }
  render() {
    const { isAlreadyEnrolled, donorAddress, giftAidTextObj } = this.props
    return (
      <DonateGiftAid
        isAlreadyEnrolled={isAlreadyEnrolled}
        showAddress={true}
        addressData={donorAddress}
        isChecked={this.state.giftAidItCheckboxStatus}
        handleGiftAidOption={this.handleGiftAidOption}
        contentMsg={giftAidTextObj}
        isMember={true}
        cdnHostName={serverProps.cdnHostName}
      />
    )
  }
}

export default connect(
  ({ external, amount }) => ({
    isAlreadyEnrolled: Boolean(
      external.donationGiftAid && external.donationGiftAid.isAlreadyEnrolled
    ),
    donorAddress:
      (external.donationGiftAid && external.donationGiftAid.address) || {},
    isGiftAidChecked: Boolean(
      external.donationGiftAid && external.donationGiftAid.isGiftAidChecked
    ),
    giftAidTextObj: {
      howitworks: i18n('giftAidIt.howitworks'),
      modalp1: i18n.html('giftAidIt.modalp1', {
        orgName: external.merchantName,
      }),
      modalp2: i18n('giftAidIt.modalp2', {
        orgName: external.merchantName,
      }),
      modalp3: i18n('giftAidIt.modalp3'),
      modalp4: i18n('giftAidIt.modalp4'),
      ok: i18n('giftAidIt.ok'),
      extraCost: i18n(
        'giftAidIt.extraCost',
        {
          currency: amount.currencyMap[amount.currencyCode],
          amount: amount.amount,
          extraAmount: (DONATE_GIFT_PERCENTAGE * amount.amount).toFixed(2),
        },
        { useHTML: true }
      ),
      learnMore: i18n('giftAidIt.learnMore'),
      alreadyDone: i18n('giftAidIt.alreadyDone'),
      optGiftaid: i18n('giftAidIt.optGiftaid'),
      taxpayer: i18n('giftAidIt.taxpayer'),
      confirmNote: i18n('giftAidIt.confirmNote'),
      updateGiftAidDeclaration: i18n.html(
        'giftAidIt.updateGiftAidDeclaration',
        { giftSettingsUrl: LINKS.ALL.GIFT_AID_DECLARATION_URL }
      ),
      applyGiftAid: i18n('giftAidIt.applyGiftAid', {
        orgName: external.merchantName,
      }),
    },
  }),
  dispatch => ({
    handleGiftAidChange: giftAidValue =>
      dispatch(changeGiftAidCheckbox(giftAidValue)),
  })
)(Donate)
